import EXIF from '@/static/js/exif.js'

export default {
    insertImg(callback){
        uni.chooseImage({
            count: 1, //默认9
            sizeType: ['compressed'], //可以指定是原图还是压缩图，默认二者都有
            sourceType: ['camera','album'], //从相机选择
            success:(res)=> {
                let tempImg = res.tempFilePaths[0]
                callback && callback(tempImg)
                //this.detail(tempImg,callback)
            }
        })
    },
    getImageTag(file, tag, suc){
        if (!file) return 0;
        return new Promise((resolve, reject) => {
            /* eslint-disable func-names */
            // 箭头函数会修改this，所以这里不能用箭头函数
            let imgObj = new Image()
            imgObj.src = file
            uni.getImageInfo({
                src: file,
                success(res) {
                    EXIF.getData(imgObj, function () {
                        EXIF.getAllTags(this);
                        let or = EXIF.getTag(this,'Orientation');//这个Orientation 就是我们判断需不需要旋转的值了，有1、3、6、8
                        resolve(suc(or))
                    });
                }
            })
        });
    },
    async comprossImage(imgSrc, maxWidth, func){
        if(!imgSrc) return 0;
        return new Promise((resolve, reject) => {
            uni.getImageInfo({
                src: imgSrc,
                success(res) {
                    let img = new Image();
                    img.src = res.path;
                    let canvas = document.createElement('canvas');
                    let obj = new Object();
                    obj.img = img;
                    obj.canvas = canvas;
                    resolve(func(obj));
                }
            });
        })
    },
    rotateImg(img, direction, canvas, times = 1){
        //最小与最大旋转方向，图片旋转4次后回到原方向
        let min_step = 0;
        let max_step = 3;
        if (img == null)return;

        //img的高度和宽度不能在img元素隐藏后获取，否则会出错
        let height = img.height;
        let width = img.width;
        let maxWidth = 700;
        let canvasWidth = width; //图片原始长宽
        let canvasHeight = height;
        let base = canvasWidth/canvasHeight;
        if(canvasWidth > maxWidth){
            canvasWidth = maxWidth;
            canvasHeight = Math.floor(canvasWidth/base);
        }
        width = canvasWidth;
        height = canvasHeight;
        let step = 0;
        if (step == null) {
            step = min_step;
        }

        if (direction == 'right') {
            step += times;
            //旋转到原位置，即超过最大值
            step > max_step && (step = min_step);
        } else if(direction == 'left'){
            step -= times;
            step < min_step && (step = max_step);
        } else {    //不旋转
            step = 0;
        }

        //旋转角度以弧度值为参数
        let degree = step * 90 * Math.PI / 180;
        let ctx = canvas.getContext('2d');
        switch (step) {
            case 1:
                canvas.width = height;
                canvas.height = width;
                ctx.rotate(degree);
                ctx.drawImage(img, 0, -height, width, height);
                break;
            case 2:
                //console.log('旋转 180度')
                canvas.width = width;
                canvas.height = height;
                ctx.rotate(degree);
                ctx.drawImage(img, -width, -height, width, height);
                break;
            case 3:
                canvas.width = height;
                canvas.height = width;
                ctx.rotate(degree);
                ctx.drawImage(img, -width, 0, width, height);
                break;
            default:  //不旋转
                canvas.width = width;
                canvas.height = height;
                ctx.drawImage(img, 0, 0, width, height);
                break;
        }
        return canvas.toDataURL("image/jpeg", 1);
    },
    async detail(url,callback){
        let maxWidth = 700;
        let Orientation = 1;
        //获取图片META信息
        await this.getImageTag(url, 'Orientation', function(e) {
            if(e != undefined) Orientation = e;
        })
        let img = null;
        let canvas = null;
        await this.comprossImage(url, maxWidth, function(e) {
            img = e.img;
            canvas = e.canvas;
        })
        let baseStr = '';
        //如果方向角不为1，都需要进行旋转
        switch(Orientation){
            case 6://需要顺时针（向右）90度旋转
                baseStr = this.rotateImg(img,'right',canvas);
                break;
            case 8://需要逆时针（向左）90度旋转
                baseStr = this.rotateImg(img,'left',canvas);
                break;
            case 3://需要180度旋转 转两次
                baseStr = this.rotateImg(img,'right',canvas, 2);
                break;
            default:
                baseStr = this.rotateImg(img,'',canvas);
                break;
        }
        console.log('旋转加压缩')
        callback && callback(baseStr)
    },
	
		// 身份证验证，支持15位和18位
	isIdcard(code) {
		//18位身份证需要验证最后一位校验位
		let pass = true;
		if (code.length == 18) {
				let city = {
					11: "北京",
					12: "天津",
					13: "河北",
					14: "山西",
					15: "内蒙古",
					21: "辽宁",
					22: "吉林",
					23: "黑龙江 ",
					31: "上海",
					32: "江苏",
					33: "浙江",
					34: "安徽",
					35: "福建",
					36: "江西",
					37: "山东",
					41: "河南",
					42: "湖北 ",
					43: "湖南",
					44: "广东",
					45: "广西",
					46: "海南",
					50: "重庆",
					51: "四川",
					52: "贵州",
					53: "云南",
					54: "西藏 ",
					61: "陕西",
					62: "甘肃",
					63: "青海",
					64: "宁夏",
					65: "新疆",
					71: "台湾",
					81: "香港",
					82: "澳门",
					91: "国外 "
				};
				if (!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(code)) {
					uni.showToast({
						   title: '身份证号格式错误',
						   icon: 'none',
						   mask: true
					})
					pass = false;
				} else if (!city[code.substr(0, 2)]) {
					uni.showToast({
						   title: '地址编码错误',
						   icon: 'none',
						   mask: true
					})
					pass = false;
				} else {
						code = code.split('');
						//∑(ai×Wi)(mod 11)
						//加权因子
						let factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
						//校验位
						let parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
						let sum = 0;
						let ai = 0;
						let wi = 0;
						for (let i = 0; i < 17; i++) {
							ai = code[i];
							wi = factor[i];
							sum += ai * wi;
						}
						let last = parity[sum % 11];
						if (parity[sum % 11] != code[17]) {
							uni.showToast({
								   title: '校验位错误',
								   icon: 'none',
								   mask: true
							})
							pass = false;
						}
		        }
		    } else {
				uni.showToast({
					   title: '身份证号码不正确',
					   icon: 'none',
					   mask: true
				})
				pass = false;
			}
		    if (!pass) {
				return false;
		    }
		    return pass;
		}
}

/**
 * 封装上传方法
 * @param url 上传地址
 * @param src 文件路径
 * @returns {Promise<any>}
 */
export const uploadFile = (url, src) => {
    uni.showLoading({
        title: '请稍候...'
    })
    return new Promise((resolve, reject) => {
        const uploadTask = uni.uploadFile({
            url:url,
            filePath: src,
            name: 'uploadFile',
            header: {
                'content-type': 'multipart/form-data',
                'token': 'test'
            },
            success: function (res) {
                uni.hideLoading()
                if (res.statusCode === 200) {
                    let result = JSON.parse(res.data)
                    if (result.code === 200) {
                        resolve(result.data.img_url)
                    } else {
					   uni.showToast({
						   title: '网络不给力，请稍后再试~',
						   icon: 'none',
						   mask: true
					   })
                        reject(res)
                    }
                } else {
				   uni.showToast({
					   title: '网络不给力，请稍后再试~',
					   icon: 'none',
					   mask: true
				   })
                }
            },
            fail: function (res) {
                uni.hideLoading()
			   uni.showToast({
				   title: '网络不给力，请稍后再试~',
				   icon: 'none',
				   mask: true
			   })
                reject(res)
            }
        })
    })
}


